import { SET_BREADCRUMB_LABEL, RESET_BREADCRUMB_LABELS } from "../actions/Breadcrumbs/types";

const initialState = {
  labels: {},
};

export default function breadcrumbsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_BREADCRUMB_LABEL:
      return {
        ...state,
        labels: {
          ...state.labels,
          [action.payload.path]: action.payload.label,
        },
      };
    case RESET_BREADCRUMB_LABELS:
      return {
        ...state,
        labels: {},
      };
    default:
      return state;
  }
}
